<template>
  <div class="detail">
    <!-- 顶部 -->
    <detailHeader />
    <!-- 头部 -->
    <logisticsHeader :detail="detail" v-if="show" />
    <!-- 详情 -->
    <div class="logisticsDetail">
      <div class="btn">
        <!--  具体计算规则设置 -->
        <span style="font-weight: bold">
          {{ $t("message.setSpecificComputingRules") }} ：</span>
        <div class="fr">
          <!-- 新增人工报价规则 -->
          <el-button size="small" type="primary" @click="showAddedQuotationRules('artificial')" class="primary"
            v-if="isAuth(421)">
            {{ $t("message.addedManualQuotationRules") }}
          </el-button>
          <!-- 新增自动报价规则 -->
          <el-button size="small" type="primary" @click="showAddedQuotationRules('auto')" v-if="isAuth(421)">
            {{ $t("message.addedAutomaticQuotationRule") }}
          </el-button>
        </div>
      </div>
      <div class="table">
        <div class="table">
          <el-table :data="tableData" :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
            <!-- 系统编号 -->
            <el-table-column align="center" label="NO" type="index" width="80">
            </el-table-column>
            <!-- 生效时间 -->
            <el-table-column align="center" :label="$t('message.effectiveTime')" prop="id" width="200">
              <template slot-scope="scope">
                <p>{{ $t("message.initiation") }}:{{ scope.row.start_at }}</p>
                <p>{{ $t("message.end") }}: {{ scope.row.end_at }}</p>
              </template>
            </el-table-column>
            <!-- 发送方式名称 -->
            <!-- <el-table-column
              align="center"
              :label="$t('message.sendingModeName')"
              prop="name"
            >
            </el-table-column> -->
            <!-- 最后修改时间 -->
            <el-table-column align="center" :label="$t('message.modificationDate')" prop="updated_at" width="160">
            </el-table-column>
            <!-- 运费计算模式 -->
            <el-table-column align="center" :label="$t('message.freightCalculationMode')" prop="remark">
              <template slot-scope="scope">
                <!-- 人工计算 自动计算 -->
                <span>
                  {{ scope.row.is_auto_calculate ? $t("message.automaticCalculation")
      : $t("message.artificialCalculation") }}
                </span>
                <!-- <span v-else> —————— </span> -->
              </template>
            </el-table-column>

            <!-- 自动签收天数 -->
            <el-table-column align="center" :label="$t('message.daysOfAutomaticReceipt')" prop="sign_receive_days">
            </el-table-column>
            <!-- 计算规则概述 -->
            <el-table-column align="center" :label="$t('message.overviewOfCalculationRules')" prop="number_count_unused"
              width="240">
              <template slot-scope="scope">
                <span v-if="scope.row.is_auto_calculate == 0"> ————</span>
                <div v-else class="text-left">
                  <div>
                    <div class="row">
                      计费方式：{{ scope.row.detail.chargeFinal == "2" ? "单配送单最终计费" : "单箱计费后累加" }}
                    </div>
                    <div class="row">
                      计价类型：{{ scope.row.detail.chargeMethod == "weight" ? "重量" : "体积" }}
                    </div>
                    <div class="row">
                      计抛方式：
                      {{ scope.row.detail.chargeWhole == "single" ? "单箱" : "整票" }}
                    </div>
                    <div class="row">抛重比例：{{ scope.row.detail.rate }}</div>
                    <div class="row">
                      是否半抛：{{ scope.row.detail.is_half == 1 ? "是" : "否" }}
                    </div>
                    <div class="row">
                      取整顺序：{{ scope.row.detail.ceilOrder == "before" ? "先取整" : "后取整" }}
                    </div>
                    <div class="row">
                      单箱额外收费：{{ scope.row.detail.otherPer }}
                    </div>
                    <div class="row">
                      整票额外收费：{{ scope.row.detail.otherWhole }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 取整区间 -->
            <el-table-column align="center" :label="$t('message.takeTheWholeRange')" prop="number_count_unused">
              <template slot-scope="scope">
                <span v-if="scope.row.is_auto_calculate == 0"> ————</span>
                <div v-else class="template">
                  <div class="row" v-for="(item, index) in scope.row.detail.weightRange" :key="index">
                    {{ item.min }} ~ {{ item.max }} 取 {{ item.ceilMethod }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 价格区间 -->
            <el-table-column align="center" :label="$t('message.priceRange')" prop="remark" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.is_auto_calculate == 0"> ————</span>
                <div v-else class="template">
                  <div class="row" v-for="(item, index) in scope.row.detail.range" :key="index">
                    {{ item.min }} ~ {{ item.max }}
                    {{ item.chargePerMethod == 1 ? "固定价" : "单价" }}
                    {{ item.price }}元
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 说明设置 -->
            <el-table-column align="center" :label="$t('message.thatSet')" prop="remark">
              <template slot-scope="scope">
                <!--  日文说明设置-->
                <p>
                  <el-button type="text" style="color: #2c96e7"
                    @click="showRemark(scope.row, $t('message.japaneseDescriptionSettings'), 'jp')" v-if="isAuth(423)">
                    {{ $t("message.japaneseDescriptionSettings") }}</el-button>
                </p>
                <!--  中文说明设置-->
                <p>
                  <el-button type="text" style="color: #2c96e7"
                    @click="showRemark(scope.row, $t('message.EnglishDescriptionSettings'), 'ch')" v-if="isAuth(424)">
                    {{ $t("message.EnglishDescriptionSettings") }}</el-button>
                </p>
              </template>
            </el-table-column>
            <!-- 生效状态 -->
            <el-table-column align="center" :label="$t('message.effectiveState')" prop="remark">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" @change="logisticsUpdateStatus(scope.row)" active-color="#2C96E7"
                  :disabled="!isAuth(425)">
                </el-switch>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber">
              <template slot-scope="scope">
                <!-- 编辑查看 -->
                <p style="margin-bottom: 10px">
                  <el-button size="mini" type="primary" class="primary" @click="edit(scope.row)" v-if="isAuth(422)">
                    {{ $t("message.editView") }}
                  </el-button>
                </p>
                <!-- 复制一条 -->
                <p>
                  <el-button size="mini" type="primary" class="dark" @click="copyOne(scope.row)" v-if="isAuth(421)">
                    {{ $t("message.toCopyA") }}
                  </el-button>
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 新增人工报价规则 -->
    <addedManualQuotationRules :ruleForm="ruleForm" v-if="artificialDialogVisible" />
    <!-- 新增自动报价规则 editAutomaticQuotationRule-->
    <addedAutomaticQuotationRule :ruleForm="ruleForm" v-if="autolDialogVisible" />
    <!-- 说明 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="remarklDialogVisible" width="900px" center>
      <div class="box">
        <quill-editor ref="myTextEditor" id="quill-editor" v-model="noteData.note" :options="quillOption">
        </quill-editor>
        <!-- <el-input
          type="textarea"
          :placeholder="title"
          v-model="noteData.note"
          show-word-limit
        >
        </el-input> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="remarklDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->

        <!-- 保存 -->
        <el-button type="primary" @click="saveNote">
          {{ $t("message.save")}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import logisticsHeader from "./components/header";
import addedManualQuotationRules from "./components/addedManualQuotationRules";
import addedAutomaticQuotationRule from "./components/addedAutomaticQuotationRule";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    detailHeader,
    logisticsHeader,
    addedManualQuotationRules,
    addedAutomaticQuotationRule,
    quillEditor,
  },
  data() {
    return {
      tableData: [],
      detail: {},
      ruleForm: {},
      show: false,
      isAdd: true,
      artificialDialogVisible: false,
      autolDialogVisible: false,
      quillOption: quillConfig,
      title: "",
      remarklDialogVisible: false,
      noteData: {
        note: "",
      },
    };
  },
  created() {
    this.logisticsDetail();
  },
  methods: {
    // 详情
    logisticsDetail() {
      let data = {
        logistics_id: this.$route.query.id,
      };
      this.show = false;
      this.$api.siteConfiguration.logisticsDetail(data).then((res) => {
        res.data.is_auto_no = res.data.is_auto_no == 1 ? true : false;
        res.data.is_vip = res.data.is_vip == 1 ? true : false;
        this.detail = res.data;

        res.data.logistics_rule.forEach((item) => {
          item.status = item.status == 1 ? true : false;
        });
        this.tableData = res.data.logistics_rule;
        this.show = true;
        console.log(res);
      });
    },
    //新增人工报价规则 弹框
    showAddedQuotationRules(type) {
      this.ruleForm = {
        logistics_id: this.$route.query.id,
        chargeFinal: "",
        start_at: "",
        end_at: "",
        chargeMethod: "",
        chargeWhole: "",
        rate: "",
        otherPer: "",
        otherWhole: "",
        is_half: false,
        ceilOrder: "",
        end_at: "",
        weightRange: [{}],
        range: [{}],
        is_cost: "",
        is_auto_calculate: "0",
        sign_receive_days: "",
      };
      this.isAdd = true;
      if (type == "artificial") {
        this.artificialDialogVisible = true;
      } else {
        this.ruleForm.is_auto_calculate = "1";
        this.autolDialogVisible = true;
      }
    },
    // 显示修改
    edit(item) {
      this.ruleForm = JSON.parse(JSON.stringify(item));
      this.isAdd = false;
      if (item.is_auto_calculate == 0) {
        this.artificialDialogVisible = true;
      } else {
        this.ruleForm = { ...this.ruleForm, ...item.detail };

        this.ruleForm.is_half = this.ruleForm.is_half == 1 ? true : false;
        console.log(this.ruleForm);
        this.autolDialogVisible = true;
      }
    },
    //计算规则-开关
    logisticsUpdateStatus(item) {
      let datas = {
        id: item.id,
        status: item.status ? 1 : 0,
      };
      this.$api.siteConfiguration.logisticsUpdateStatus(datas).then((res) => {
        this.$message.success(res.msg);
      });
    },
    // 复制一条
    copyOne(item) {
      let datas = JSON.parse(JSON.stringify(item));

      if (item.is_auto_calculate == 1) {
        datas = { ...datas, ...item.detail };
      }
      datas.status = 0;
      let start_at = item.end_at.split("-")[0] - 0 + 1;
      // 复制规则的开始时间统一从当天 00:00:00 生效
      datas.start_at = start_at + item.end_at.substr(4, 6) + " 00:00:00";
      let end_at = item.end_at.split("-")[0] - 0 + 2;
      datas.end_at = end_at + item.end_at.substr(4);

      this.$api.siteConfiguration.logisticsAddRuleConfig(datas).then((res) => {
        this.$message.success(res.msg);
        this.logisticsDetail();
      });
    },
    //显示说明
    showRemark(item, title, type) {
      console.log(title);
      this.title = title;
      this.noteData.id = item.id;
      this.noteData.type = type;
      if (type == "jp") {
        this.noteData.note = item.note_jp;
      } else {
        this.noteData.note = item.note_cn;
      }
      this.remarklDialogVisible = true;
    },
    // 保存说明
    saveNote() {
      if (this.noteData.type == "jp") {
        this.$api.siteConfiguration
          .logisticsUpdateNoteJp(this.noteData)
          .then((res) => {
            this.$message.success(res.msg);
            this.logisticsDetail();
            this.remarklDialogVisible = false;
          });
        //  this.$api.
      } else {
        this.$api.siteConfiguration
          .logisticsUpdateNoteCn(this.noteData)
          .then((res) => {
            this.$message.success(res.msg);
            this.logisticsDetail();
            this.remarklDialogVisible = false;
          });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.detail {
  min-width: 1910px;
}

.logisticsDetail {
  padding: 24px;
  margin: 24px;
  background-color: #f8f8f8;
  border-radius: 8px;

  .btn {
    font-size: 16px;
    line-height: 32px;
    margin-bottom: 20px;
  }
}

.text-left {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  text-align: left;
}

.template {
  height: 190px;
  overflow-y: auto;
}

.box {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 200px;
  }

  /deep/.ql-editor {
    height: 200px;
  }
}
</style>
